import { useSyncExternalStore, useCallback } from 'react';
import {
    subscribeTheme,
    getThemeSnapshot,
    setThemePrefs,
    applyContentSeed,
    clearContentSeed
} from '../services/themeService';

export function useTheme() {
    const themeState = useSyncExternalStore(subscribeTheme, getThemeSnapshot);

    const setSeedColor = useCallback((seedColor) => setThemePrefs({ seedColor }), []);
    const setIsDark = useCallback((isDark) => setThemePrefs({ isDark }), []);
    const setThemeMode = useCallback((themeMode) => setThemePrefs({ themeMode }), []);
    const setContrastLevel = useCallback((contrastLevel) => setThemePrefs({ contrastLevel }), []);
    const setDynamicContent = useCallback((dynamicContent) => setThemePrefs({ dynamicContent }), []);

    return {
        ...themeState,
        setSeedColor,
        setIsDark,
        setThemeMode,
        setContrastLevel,
        setDynamicContent,
        extractAndApplyFromImage: applyContentSeed,
        clearContentSeed
    };
}
